import { Box, Divider, ListItemSelect, Text, Thumbnail } from '@wix/design-system';
import React, { useContext, useMemo } from 'react';
import { RicosContext } from 'ricos-context';

import { GridPollIcon, ListPollIcon, WithImagePollIcon } from '../../assets/icons';
import { IMAGE_AND_LIST_OPTION, IMAGE_GRID_OPTION, TEXT_LIST_OPTION } from '../../dataHooks';
import type { PresetType } from './preset-data';
import { PRESET_TYPE } from './preset-data';
import classes from './preset-picker.scss';

type PresetPickerProps = {
  onPollAdd: (type: PresetType) => void;
};

export const PresetPicker: React.FC<PresetPickerProps> = ({ onPollAdd }) => {
  const { t, isMobile } = useContext(RicosContext);

  const dataSource = useMemo(
    () => [
      {
        value: PRESET_TYPE.LIST,
        label: t('Poll_Presets_Popup_Option_TextList'),
        icon: ListPollIcon,
        dataHook: TEXT_LIST_OPTION,
      },
      {
        value: PRESET_TYPE.LIST_WITH_IMAGE,
        label: t('Poll_Presets_Popup_Option_TextListAndMainImage'),
        icon: WithImagePollIcon,
        dataHook: IMAGE_AND_LIST_OPTION,
      },
      {
        value: PRESET_TYPE.GRID,
        label: t('Poll_Presets_Popup_Option_ImagesGrid'),
        icon: GridPollIcon,
        dataHook: IMAGE_GRID_OPTION,
      },
    ],
    [t]
  );

  const Component = isMobile ? PresetPickerVertical : PresetPickerHorizontal;

  return <Component dataSource={dataSource} onPollAdd={onPollAdd} />;
};

type ThumnailPickerCommon = {
  dataSource: {
    value: PresetType;
    label: string;
    icon: any;
    dataHook: string;
  }[];
  onPollAdd: (type: PresetType) => void;
};

const PresetPickerVertical: React.FC<ThumnailPickerCommon> = ({ dataSource, onPollAdd }) => {
  return (
    <Box direction="vertical">
      {dataSource.map(item => (
        <>
          <ListItemSelect
            key={item.value}
            title={item.label}
            dataHook={item.dataHook}
            onClick={() => onPollAdd(item.value)}
            size="medium"
            prefix={
              <div
                style={{
                  alignItems: 'center',
                  justifyContent: 'center',
                  display: 'flex',
                  border: '1px solid #d3d3d3',
                  marginBlock: '10px',
                }}
              >
                <item.icon />
              </div>
            }
          />
          <Divider />
        </>
      ))}
    </Box>
  );
};

const PresetPickerHorizontal: React.FC<ThumnailPickerCommon> = ({ dataSource, onPollAdd }) => {
  return (
    <Box align="space-between" direction="horizontal" className={classes.presetPicker}>
      {dataSource.map(item => (
        <Thumbnail
          key={item.value}
          size="small"
          dataHook={item.dataHook}
          title={<Text size="tiny">{item.label}</Text>}
          onClick={() => {
            onPollAdd(item.value);
          }}
          image={
            <div
              style={{
                border: '1px solid #d3d3d3',
              }}
            >
              <item.icon />
            </div>
          }
        />
      ))}
    </Box>
  );
};
